module.exports = __webpack_public_path__ + "static/img/foot_solider2.6b7a3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/foot_solider2.png
// module id = W52z
// module chunks = 0